import { Spacing } from '@persona-id/design-tokens';
import { CircleAlertIcon } from '@persona-id/design-tokens/icons';
import { ReactNode } from 'react';
import styled from 'styled-components';

import Banner from 'design-system/components/Banner';
import { LocalStorageKey } from 'lib/clients/StorageClient';
import useLocalStorage from 'lib/hooks/useLocalStorage';

const IconContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-right: ${Spacing[4]};
`;

const MessageContainer = styled('div')`
  display: flex;
  flex-direction: row;
  width: 90%;
  margin: ${Spacing[2]} 0px ${Spacing[2]} ${Spacing[2]};
`;

interface DismissibleBannerProps {
  children: ReactNode;
  localStorageKey: LocalStorageKey;
}

export default function DismissibleBanner({ children, localStorageKey }: DismissibleBannerProps) {
  const [isPermanentlyDismissed, setPermanentlyDismissed] = useLocalStorage<boolean>(
    localStorageKey,
    false,
  );

  const handleClickDontShowAgain = () => {
    setPermanentlyDismissed(true);
  };

  return isPermanentlyDismissed ? null : (
    <Banner
      data-test='dismissible-banner'
      id='api__dismissible-banner'
      onClose={handleClickDontShowAgain}
      variant='warning'
    >
      <MessageContainer>
        <IconContainer>
          <CircleAlertIcon size='12' />
        </IconContainer>
        <div>{children}</div>
      </MessageContainer>
    </Banner>
  );
}
